import { render, staticRenderFns } from "./SkillsBuilder.vue?vue&type=template&id=399f2e82&scoped=true&"
import script from "./SkillsBuilder.vue?vue&type=script&lang=js&"
export * from "./SkillsBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SkillsBuilder.vue?vue&type=style&index=0&id=399f2e82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f2e82",
  null
  
)

export default component.exports